import { useMemo } from "react"

const rtlLocales: string[] = [
	"ar", // Arabic
	"he", // Hebrew
]
export const useDirection = (locale: string): "ltr" | "rtl" => {
	return useMemo(() => getDirection(locale), [locale])
}

export const getDirection = (locale: string): "ltr" | "rtl" =>
	rtlLocales.some((val) => locale.startsWith(val)) ? "rtl" : "ltr"
